export enum Errors {
    CONNECTION_FAILED = 'ERRORS.CONNECTION_FAILED',
    UNAUTHORIZED = 'ERRORS.UNAUTHORIZED',
    ALREADY_LOGGED_IN = "ERRORS.UNAUTHORIZED_ACTIVE_SESSION",
    PROVIDE_USERNAME_PASSWORD = "ERRORS.CREDENTIALS_MISSING"
}